$(document).ready(function() {
    const tabCollectionSections = document.querySelectorAll('.tab-collections-wrapper');
    function initializeSwiper(selector) {
      return new Swiper(selector, {
        direction: 'horizontal',
        speed: 1000,
        // width: 500,
        spaceBetween: 30,
        autoplay: false,
        navigation: {
          nextEl: `${selector} .swiper-button-next`,
          prevEl: `${selector} .swiper-button-prev`,
        },
        breakpoints: {
          320: {
            slidesPerView: 3.5,
            spaceBetween: 10
          },
          // when window width is >= 480px
          768: {
            slidesPerView: 4,
            spaceBetween: 10
          },
          // when window width is >= 640px
          // 1242: {
          //   slidesPerView: 5.5,
          //   spaceBetween: 40
          // },
          // 1580: {
          //   slidesPerView: 6.5,
          //   spaceBetween: 40
          // }
        }
      })
    }
    function initializeSwipersForActiveTab(sectionId) {
      const activeTab = document.querySelector(`[data-section-id="${sectionId}"] .tab-content .tab-pane.active`);
      if (activeTab) {
          initializeSwiperForTab(activeTab);
      }
    }
    function initializeSwiperForTab(tab) {
      const carousel = tab.querySelector('.swiper-container');
      const carouselId = carousel.dataset.carouselId;
      initializeSwiper(`[data-carousel-id="${carouselId}"]`);
    }
    tabCollectionSections.forEach(section => {
      const sectionId = section.getAttribute('data-section-id');
      initializeSwipersForActiveTab(sectionId);
      switchTab(sectionId)
    })

    function switchTab(sectionId) {
      document.querySelectorAll(`[data-section-id="${sectionId}"] .nav-tabs .nav-link`).forEach(tab => {
      tab.addEventListener('click', (evt) => {
        document.querySelectorAll(`[data-section-id="${sectionId}"] .nav-tabs .nav-link`).forEach(tab => {
          tab.classList.remove('active');
        });
        tab.classList.add('active');

        // const tabEle = evt.target;
        const id = tab.getAttribute('data-bs-target');
        document.querySelectorAll(`[data-section-id="${sectionId}"] .tab-content .tab-pane`).forEach(pane => {
          pane.classList.remove('active');
          pane.classList.remove('show');
        });
        const currentPane = document.querySelector(`[data-section-id="${sectionId}"] .tab-content .tab-pane#${id}`)
        currentPane.classList.add('active');
        currentPane.classList.add('show');
        initializeSwipersForActiveTab(sectionId);
      });
    });
    }
  })